import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import $api from './api'
Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/swiper-bundle.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
Vue.prototype.$api = $api
Vue.use(ElementUI, { locale })
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
import tools from './utils/tool.js'
import animate from 'animate.css'
import VueAnimateNumber from 'vue-animate-number'
import 'wowjs/css/libs/animate.css'
import "./Font/Oswald/oswald.css"
Vue.use(animate)
Vue.use(tools)
Vue.use(VueAnimateNumber)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
